module.exports = __webpack_public_path__ + "img/app3.5e3fa60e.png";